import React from "react";
import { Container, Box, Typography } from "@mui/material";
import DGVLogo from "../images/DGVLogo";

const DeletePageTop = () => {

    return (
        <Container component="main" maxWidth="md">
            <Box
                sx={{
                    marginTop: { xs: 8, sm: 6, md: 10 },
                    marginBottom: { xs: 4, sm: 3, md: 5 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
            <DGVLogo topNavLogo={false} />

            <Typography component="h1" variant="h5">Delete your account</Typography>
            </Box>
        </Container>
    );
};

export default DeletePageTop;
